// Push notification permission + subscribe flow — call this after login.
// Wraps the shipped /api/push/* backend.
import { api } from "./api";

const urlBase64ToUint8Array = (b64) => {
  const padding = "=".repeat((4 - (b64.length % 4)) % 4);
  const s = (b64 + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(s);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export async function registerSwAndSubscribe({ silent = true } = {}) {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) return null;
  try {
    const reg = await navigator.serviceWorker.register("/sw.js");
    // Ask permission — silent=true skips if already denied.
    let perm = Notification.permission;
    if (perm === "default") perm = await Notification.requestPermission();
    if (perm !== "granted") return { granted: false };

    const keyResp = await api.get("/config/features");
    const vapidResp = await api.get("/push/vapid-public-key");
    const publicKey = vapidResp.data?.public_key;
    if (!publicKey) return { granted: true, subscribed: false, reason: "VAPID public key missing on server (mock mode)." };

    const sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey),
    });
    const raw = sub.toJSON();
    await api.post("/push/subscribe", {
      endpoint: raw.endpoint,
      keys_p256dh: raw.keys?.p256dh || "",
      keys_auth: raw.keys?.auth || "",
      ua: navigator.userAgent,
    });
    return { granted: true, subscribed: true };
  } catch (e) {
    if (!silent) console.warn("push register failed", e);
    return { granted: false, error: String(e) };
  }
}
